module.exports = __webpack_public_path__ + "static/img/4bg_16.efa3b0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_16.png
// module id = 701
// module chunks = 1